import { Typography } from "@packages/ds";
import styled from "styled-components";

import { Link as DsLink } from "ds/Button";

export const EnvironmentTitle = styled(Typography.Title)`
  margin-bottom: 80px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const Help = styled.p`
  margin: 0 0 24px 0;
  color: var(--section-ebony-light-color, var(--ebony-light));
  font-size: 14px;
  svg {
    margin: 0 8px 0 0;
    vertical-align: middle;
  }
`;

export const Link = styled(DsLink)`
  text-transform: none;
`;
